import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';

@Component({
    selector: 'app-avatar-cropper',
    templateUrl: './avatar-cropper.component.html',
    styleUrls: ['./avatar-cropper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AvatarCropperComponent implements OnInit {
  @Input() avatar: string;
  lastCrop: ImageCroppedEvent = null;
  currentCrop: ImageCroppedEvent = null;
  saved = new EventEmitter<ImageCroppedEvent>();
  @ViewChild(ImageCropperComponent, { static: true })
  cropper: ImageCropperComponent;

  constructor() {}

  imageCropped(event: ImageCroppedEvent) {
    console.log(event);
    this.currentCrop = event;
    // fetch(event.base64)
    //   .then((res) => res.blob())
    //   .then((r) => (this.currentCrop = r));
  }

  ngOnInit(): void {}

  ready() {
    console.log('READY', this.currentCrop);
    if (this.currentCrop) {
      this.cropper.cropper = { ...this.currentCrop.cropperPosition };
      this.cropper.crop();
    }
  }

  save() {
    console.log(this.cropper);
    this.saved.emit(this.currentCrop);
  }
}
